import React, { useState, useEffect } from 'react';
import brand1 from '../src/images/brand3.png';
import brand8 from '../src/images/brand 8.png';
import brand3 from '../src/images/brand4.png';
import brand4 from '../src/images/brand5.png';
import brand5 from '../src/images/brand6.png';
import brand6 from '../src/images/brand7.png';
import brand9 from '../src/images/brand9.png';
import brand10 from '../src/images/brand10.png';
import brand11 from '../src/images/brand11.png';
import './gallery.css';




const SlideShow = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
    }, 3000);
 
    return () => clearInterval(interval);
  }, [images.length, currentSlide]);
 
  useEffect(() => {
    const slidesContainer = document.querySelector('.slides');
    if (slidesContainer) {
      slidesContainer.style.transform = `translateX(-${currentSlide * (100 + 30)}px)`;
    }
  }, [currentSlide]);
  return (
    <section>
       
        <div className="container-fluid ">
    <div className="slideshow-container">
      <div className="slides">
        {images.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img
              src={image.src}
              className="slide-image"
            />
          </div>
        ))}
      </div>
    </div>
    </div>
  
    </section>
  );
        };
 
const Gallery = () => {
  const images = [   
    { src: brand1},
   
    {src: brand3},
    {src: brand10},
    {src: brand4},
  
    {src: brand5},
    {src: brand6},
    {src: brand8},
    {src: brand9},
    {src: brand11},
  
   
    
      ];
   
 
  return (
    <div className="p-5 d-md-flex" style={{backgroundColor:'#eeee' ,alignItems:'center'}}>
        <div style={{paddingRight:'10px',borderRight:'1px solid gray'}}>
            <h6  style={{fontStyle:'oblique',color:'rgb(134, 198, 39)',paddingLeft:'5px',letterSpacing:'1px'}}>We choose</h6>
            <div style={{letterSpacing:'2px'}}>
        <h3 className='text-secondary'>THE  BEST </h3><h1 style={{color:'hsl(255, 93%, 30%)'}}>BRANDS</h1><h3 className='text-secondary'>FOR YOU</h3>
        </div>
        </div>
        <div style={{width:'90%'}}>
<SlideShow images={images} />
</div>
    </div>
   
  );
};
 
export default Gallery;